export const isUserLogged = (state) => state.login.isLogged;